/**
 * Author : zhengyanfeng.
 * Date   : 2021/1/5.
 * File   : province. 城市id对象
 */
export default {
  '350203': {
    position: {
      left: '815px',
      top: '740px'
    },
    background: require('../../mapPicture/fujian/xiamen/siming.png'),
    diningList: [
      {
        departmentName: '厦门大学',
        departmentId: 'D9042F27716F14417BE5293FB2F27FB93',
        position: {
          left: '35px',
          top: '90px'
        },
        active: '01'
      }
    ]
  }
}



//////////////////
// WEBPACK FOOTER
// ./static/mapPoint/diningPoint/fujian/xiamen.js
// module id = null
// module chunks = 